import axios from "axios"
import { authHeader } from "../../utils"
import { CREATE_SUNDRY_ITEM, CREATE_SUNDRY_TRANSACTION, CREATING_SUNDRY_ITEM, CREATING_SUNDRY_TRANSACTION, DELETE_SUNDRY_ITEM, DELETING_SUNDRY_ITEM, GET_SUNDRY_ACCOUNTS, GET_SUNDRY_ITEMS, GETTING_SUNDRY_ACCOUNTS, GETTING_SUNDRY_ITEMS, SET_SUCCESS, SUNDRIES_ERROR, UPDATE_SUNDRY_ITEM, UPDATING_SUNDRY_ITEM } from "../types"

export const createSundryTransaction = (payload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: CREATING_SUNDRY_TRANSACTION,
            payload: true
        })
        
        const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/sundries/sundry-transactions`, payload, { headers })
        
        dispatch({
            type: CREATE_SUNDRY_TRANSACTION,
            payload: response.data.data
        })

        dispatch({
            type: SET_SUCCESS,
            payload: response.data.data.message
        })
        
    }
    catch(error){
        console.log(error)
        dispatch({
            type: SUNDRIES_ERROR,
            error
        })
    }
}

export const clearCreatedSundryTransaction = () => async (dispatch) => {       
    dispatch({
        type: CREATE_SUNDRY_TRANSACTION,
        payload: null
    })
}

export const createSundryItem = (staffPayload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: CREATING_SUNDRY_ITEM,
            payload: true
        })
        const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/sundries/sundry-items`, staffPayload, { headers })
        
        dispatch({
            type: CREATE_SUNDRY_ITEM,
            payload: response.data.data
        })

        dispatch({
            type: SET_SUCCESS,
            payload: 'Sundry item created successfully'
        })
        
    }
    catch(error){
        console.log(error)
        dispatch({
            type: SUNDRIES_ERROR,
            error
        })
    }
}

export const clearCreatedSundryItem = (invitationCode) => async (dispatch) => {       
    dispatch({
        type: CREATE_SUNDRY_ITEM,
        payload: null
    })
}

export const updateSundryItem = (itemId, payload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: UPDATING_SUNDRY_ITEM,
            payload: itemId
        })

        const response = await axios.patch(
            `${process.env.REACT_APP_BASE_URL}/sundries/sundry-items/${itemId}`, payload, 
            { headers }
        )
        
        dispatch({
            type: UPDATE_SUNDRY_ITEM,
            payload: response.data.data
        })

        dispatch({
            type: SET_SUCCESS,
            payload: 'Sundry item updated successfully'
        })
        
    }
    catch(error){
        console.log(error)
        dispatch({
            type: SUNDRIES_ERROR,
            error
        })
    }
}

export const clearUpdatedSundryItem = () => async (dispatch) => {       
    dispatch({
        type: UPDATE_SUNDRY_ITEM,
        payload: null
    })
}

export const deleteSundryItem = (itemId) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: DELETING_SUNDRY_ITEM,
            payload: itemId
        })

        await axios.delete(
            `${process.env.REACT_APP_BASE_URL}/sundries/sundry-items/${itemId}`, 
            { headers }
        )
        
        dispatch({
            type: DELETE_SUNDRY_ITEM,
            payload: itemId
        })

        dispatch({
            type: SET_SUCCESS,
            payload: 'Sundry item deleted successfully'
        })
        
    }
    catch(error){
        console.log(error)
        dispatch({
            type: SUNDRIES_ERROR,
            error
        })
    }
}

export const clearDeletedSundryItem = () => async (dispatch) => {       
    dispatch({
        type: DELETE_SUNDRY_ITEM,
        payload: null
    })
}

export const fetchSundryItems= (filters, page, perPage) => async dispatch => {    
    try{
        const headers = authHeader()
        let requestUrl = 'sundries/sundry-items'

        dispatch( {
            type: GETTING_SUNDRY_ITEMS,
            payload: true
        })

        if(filters && filters !== '') {
            requestUrl += `&${filters}`
        }

        if(page && page!=='') {
            requestUrl += `${requestUrl.includes('?') ? '&' : '?'}page=${page}`
        }

        if(perPage && perPage!=='') {
            requestUrl += `${requestUrl.includes('?') ? '&' : '?'}perPage=${perPage}`
        }

        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/${requestUrl}`, { headers })


        dispatch( {
            type: GET_SUNDRY_ITEMS,
            payload: response.data.data
        })
        
    }
    catch(error){
        console.log(error)
        dispatch( {
            type: SUNDRIES_ERROR,
            error
        })
    }
}

export const fetchSundryAccounts = (filters, page, perPage) => async dispatch => {    
    try{
        const headers = authHeader()
        let requestUrl = 'sundries/sundry-accounts?expand=student'

        dispatch( {
            type: GETTING_SUNDRY_ACCOUNTS,
            payload: true
        })

        if(filters && filters !== '') {
            requestUrl += `&${filters}`
        }

        if(page && page!=='') {
            requestUrl += `${requestUrl.includes('?') ? '&' : '?'}page=${page}`
        }

        if(perPage && perPage!=='') {
            requestUrl += `${requestUrl.includes('?') ? '&' : '?'}perPage=${perPage}`
        }

        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/${requestUrl}`, { headers })


        dispatch( {
            type: GET_SUNDRY_ACCOUNTS,
            payload: response.data.data
        })
        
    }
    catch(error){
        console.log(error)
        dispatch( {
            type: SUNDRIES_ERROR,
            error
        })
    }
}
